export default {
    path: '/dean',
    name: 'dean',
    meta: {
        title: '院长端'
    },
    component: resolve => require(['@/views/boss.vue'], resolve),
    redirect: '/dean/home', 
    children: [
        {
            path: '/dean/home',
            name: 'home',
            meta: [{
                path: '/dean/home',
                title: '首页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/dean/home.vue'], resolve),
        },
        {
            path: '/dean/realTimeMonitor',
            name: 'realTimeMonitor',
            meta: [{
                path: '/dean/realTimeMonitor',
                title: '实时监测',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/dean/realTimeMonitor.vue'], resolve),
        },
        {
            path: '/dean/record',
            name: 'record',
            meta: [{
                path: '/dean/record',
                title: '工作记录',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/dean/record.vue'], resolve),
        },
        {
            path: '/dean/workAnalysis',
            name: 'workAnalysis',
            meta: [{
                path: '/dean/workAnalysis',
                title: '工效分析',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/dean/workAnalysis.vue'], resolve),
        },
        {
            path: '/dean/realTimeMonitoringtwo',
            name: 'realTimeMonitoringtwo',
            meta: [{
                path: '/dean/realTimeMonitor',
                title: '实时监测',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/dean/realTimeMonitoringtwo.vue'], resolve),
        },
        {
          path: '/dean/toilet',
          name: 'toilet',
          meta: [{
              path: '/dean/realTimeMonitor',
              title: '实时监测',
              color: "#f2f2f2"
          }],
          component: resolve => require(['@/views/dean/toilet.vue'], resolve),
        },
        {
            path: '/dean/oldHealthy',
            name: 'oldHealthy',
            meta: [{
                path: '/dean/oldHealthy',
                title: '老人健康数据',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/dean/oldHealthy.vue'], resolve),
        },
        {
          path: '/dean/dataSummary',
          name: 'dataSummary',
          meta: [{
              path: '/dean/dataSummary',
              title: '当日数据汇总',
              color: "#f2f2f2"
          }],
          component: resolve => require(['@/views/dean/dataSummary.vue'], resolve),
      },
      {
        path: '/dean/dataView',
        name: 'dataView',
        meta: [{
            path: '/dean/dataView',
            title: '累计数据查看',
            color: "#f2f2f2"
        }],
        component: resolve => require(['@/views/dean/dataView.vue'], resolve),
    },
        {
            path: '/dean/moreBed',
            name: 'moreBed',
            meta: [{
                path: '/protect/moreBed',
                title: '更多床位信息',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/protect/moreBed.vue'], resolve),
        },
    ],
}